import Vue from 'vue';
import SchdeduledTasksStatic from './scheduledTasks/scheduledTasksStatic'

const state = {
    scheduledTasks: [],
    isLoadingScheduledTasks: false,
    lastScheduleTasksDownloadPagination: null,
    selectedScheduledTask: null,
    taskStates: SchdeduledTasksStatic.taskStates,
    typeOptions: SchdeduledTasksStatic.typeOptions,
    repetitionOptions: SchdeduledTasksStatic.repetitionOptions,
    weekDayOptions: SchdeduledTasksStatic.weekDayOptions,
    monthDayOptions: SchdeduledTasksStatic.monthDayOptions,
    taskExecutionResult: SchdeduledTasksStatic.taskExecutionResult,
    taskProcessType: SchdeduledTasksStatic.taskProcessType,
};

const getters = {
    getScheduledTasks: (state) => state.scheduledTasks,
    getIsLoadingScheduledTasks: (state) => state.isLoadingScheduledTasks,
    getSelectedScheduledTask: (state) => state.selectedScheduledTask,
    getTaskStates: (state) => state.taskStates,
    getTypeOptions: (state) => state.typeOptions,
    getRepetitionOptions: (state) => state.repetitionOptions,
    getWeekDayOptions: (state) => state.weekDayOptions,
    getMonthDayOptions: (state) => state.monthDayOptions,
    getTaskExecutionResult: (state) => state.taskExecutionResult,
    getTaskProcessType: (state) => state.taskProcessType,
};

const actions = {

    createScheduleTask: ({dispatch, state, rootState}, scheduledTask) => {
        scheduledTask.supplierId = rootState.user.account.supplierId
        return axios.post('/api/Supplier/ScheduleTask_INVOICE_ChannelPeriod_Create',
            scheduledTask
        ).then(response => {
            if(response.status == 200){
                return true
            }
            return false
        }).catch(err => {
            return false
        })
    },

    editScheduleTask: ({dispatch, state, rootState}, scheduledTask) => {
        scheduledTask.supplierId = rootState.user.account.supplierId
        scheduledTask.scheduleTaskId = scheduledTask.id

        return axios.post('/api/Supplier/ScheduleTask_INVOICE_ChannelPeriod_Edit',
            scheduledTask
        ).then(response => {
            if(response.status == 200){
                return true
            }
            return false
        }).catch(err => {
            return false
        })
    },

    pauseScheduleTask: ({dispatch, state, rootState}, scheduledTask) => {

        return axios.get('/api/Supplier/SetScheduleTaskStatus',{
            params: {
                supplierId: rootState.user.account.supplierId,
                scheduleTaskId: scheduledTask.id,
                taskStatus: 0
            }
        }).then(response => {
            if(response.status == 200){
                return true
            }
            return false
        }).catch(err => {
            return false
        })
    },

    resumeScheduleTask: ({dispatch, state, rootState}, scheduledTask) => {

        return axios.get('/api/Supplier/SetScheduleTaskStatus',{
            params: {
                supplierId: rootState.user.account.supplierId,
                scheduleTaskId: scheduledTask.id,
                taskStatus: 1
            }
        }).then(response => {
            if(response.status == 200){
                return true
            }
            return false
        }).catch(err => {
            return false
        })
    },

    downloadScheduledTasks: ({state, commit, rootState}, payload) => {
        commit('SET_IS_LOADING_SCHEDULED_TASKS', true)

        // save used pagination so we can refresh the page if we need to
        if(payload && payload.currentPage && payload.paginationSettings.itemsPerPage){
            state.lastScheduleTasksDownloadPagination = {
                'page': payload.currentPage,
                'pageSize': payload.paginationSettings.itemsPerPage,
            }
        }

        return axios.get('/api/Supplier/GetScheduleTasks', {
            params:{
                'page': payload && payload.currentPage? payload.currentPage : state.lastScheduleTasksDownloadPagination.page,
                'pageSize': payload && payload.paginationSettings.itemsPerPage? payload.paginationSettings.itemsPerPage : state.lastScheduleTasksDownloadPagination.pageSize,
                's.supplierId': rootState.user.account.supplierId,
                's.isActive': true, // optional ?
            }
        }).then(response => {
            commit('SET_IS_LOADING_SCHEDULED_TASKS', false)
            if(response.status == 200){
                commit('SET_SCHEDULED_TASKS', response.data.result)
                return response
            }
            return false
        }).catch(err => {
            commit('SET_IS_LOADING_SCHEDULED_TASKS', false)
            return false
        })
    },

    selectScheduleTask: ({state, commit}, scheduledTask) => {
        console.log('selected schedule task', scheduledTask);
        commit('SET_SELECTED_SCHEDULED_TASKS', scheduledTask)
    },

    deleteScheduledTask: ({state, commit, rootState}, scheduleTask) => {
        console.log('deleteScheduledTask');
        return axios.get('/api/Supplier/DeleteScheduleTask', {
            params:{
                'supplierId': rootState.user.account.supplierId,
                'scheduleTaskId': scheduleTask.id
            }
        }).then(response => {
            if(response.status == 200){
                return response
            }
            return false
        }).catch(err => {
            return false
        })
    },

    getScheduleTaskHistory: ({state, commit, rootState}, payload) => {
        console.log('getScheduleTaskHistory');
        return axios.get('/api/Supplier/GetScheduleTaskHistory', {
            params:{
                'page': payload.pagination.currentPage,
                'pageSize': payload.paginationSettings.itemsPerPage,
                's.supplierId': rootState.user.account.supplierId,
                's.scheduleTaskId': payload.scheduleTask.id,
                's.dateStart': null,
                's.dateEnd': null,
            }
        }).then(response => {
            if(response.status == 200){
                return response
            }
            return false
        }).catch(err => {
            return false
        })
    },

    replayScheduleTask: ({state, commit, rootState}, scheduleTask) => {
        console.log('replayScheduleTask');
        return axios.get('/api/Supplier/ReplayScheduleTask', {
            params:{
                'supplierId': rootState.user.account.supplierId,
                'scheduleTaskInstanceId': scheduleTask.id,
                'nextExecutionDate': moment().format('YYYY-MM-DD HH:mm:ss'),
            }
        }).then(response => {
            if(response.status == 200){
                return response
            }
            return false
        }).catch(err => {
            return false
        })
    },
};

const mutations = {
    SET_SCHEDULED_TASKS: (state, scheduledTasks) => {
        state.scheduledTasks = scheduledTasks
    },

    SET_IS_LOADING_SCHEDULED_TASKS: (state, payload) => {
        console.log('SET_IS_LOADING_SCHEDULED_TASKS', payload);
        state.isLoadingScheduledTasks = payload
    },

    SET_SELECTED_SCHEDULED_TASKS: (state, scheduledTask) => {
        state.selectedScheduledTask = scheduledTask
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/scheduledTasks.js